
import { Link } from "react-router-dom";
import safety from "../../Images/safety.jpg";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";

export default function Safety() {
  return (
    <>
    <div
  className=" relative w-full min-h-[300px] sm:min-h-[400px] lg:min-h-[350px]
    bg-cover bg-[center_50%] flex items-center pt-28 sm:pt-32 "
  style={{ backgroundImage: `url(${safety})` }}
>
  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black/55"></div>

  {/* Content */}
  <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h1
      className=" text-white font-extrabold text-center text-3xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-4xl
        leading-tight pt-5 pb-1 max-w-5xl -mt-12 sm:mt-0 mx-auto drop-shadow-[0_6px_20px_rgba(0,0,0,0.7)]" >
      7x Safety
    </h1>
  </div>
  </div>

    <div className="max-w-7xl mx-auto px-6 py-14 text-black-900">
        <p>
         SmileExpert team Dental has been setting benchmarks to ensure the safety of its Patients, Doctors, Dental Assistants and other Clinical Staff. Sterilization and Safety has always been our top priority. After considering the Standard Operating Procedures and advisories issued by various regulatory bodies; we have established Enhanced Safety Protocols combatting 2019-nCoV referred to as 7X Safety @SmileExpert


        </p>
    </div>

    <div className="max-w-7xl mx-auto px-6 space-y-2">

  {/* ITEM 01 */}
  <div className="flex gap-6">
    <div className="w-16 h-16 px-2 flex flex-shrink-0 items-center justify-center bg-blue-400 text-white text-xl font-bold">
      01
    </div>
    <div>
      <h3 className="font-semibold text-lg text-gray-900">
        Frequent Disinfection of all Surfaces & Rigorous Hand-Sanitizing Protocols in Place.
      </h3>
      <p className="text-gray-600 mt-2 text-sm leading-relaxed">
        Regular disinfection of all surfaces coming in human contact is ensured. Sample testing is done by an accredited external pathology lab and ‘Free from Infection’ certificates are maintained in each clinic.
      </p>
    </div>
  </div>

  {/* ITEM 02 */}
  <div className="flex gap-6">
    <div className="w-16 h-16 flex flex-shrink-0 items-center justify-center bg-blue-400 text-white text-xl font-bold">
      02
    </div>
    <div>
      <h3 className="font-semibold text-lg text-gray-900">
        4-Step Sterilisation for Instruments and Hand Rotors
      </h3>
      <p className="text-gray-600 mt-2 text-sm leading-relaxed">
        Adherence to SmileExpert Dental’s trademarked process to ensure a 100% sterile and safe environment for patients and staff.
      </p>
    </div>
  </div>

  {/* ITEM 03 */}
  <div className="flex gap-6">
    <div className="w-16 h-16 flex flex-shrink-0 items-center justify-center bg-blue-400 text-white text-xl font-bold">
      03
    </div>
    <div>
      <h3 className="font-semibold text-lg text-gray-900">
        Complete Global Standard PPE for Dentists and Dental Assistants
      </h3>
      <p className="text-gray-600 mt-2 text-sm leading-relaxed">
        Our policy ensures use of best in class & global standard PPE’s for all dentists and dental assistants to ensure that there is no cross-contamination between patients, thereby ensuring patient and staff safety.
      </p>
    </div>
  </div>

  {/* ITEM 04 */}
  <div className="flex gap-6">
    <div className="w-16 h-16 flex flex-shrink-0 items-center justify-center bg-blue-400 text-white text-xl font-bold">
      04
    </div>
    <div>
      <h3 className="font-semibold text-lg text-gray-900">
        Responsible Bio-Medical Waste Disposal
      </h3>
      <p className="text-gray-600 mt-2 text-sm leading-relaxed">
        SmileExpert team has always worked with Government regulations to dispose of biomedical waste. The new policy ensures that all extra PPE material should be disposed of as per WHO guidelines.
      </p>
    </div>
  </div>

  {/* ITEM 05 */}
  <div className="flex gap-6">
    <div className="w-16 h-16 flex flex-shrink-0 items-center justify-center bg-blue-400 text-white text-xl font-bold">
      05
    </div>
    <div>
      <h3 className="font-semibold text-lg text-gray-900">
        Digital AI-Enabled Proprietary software for complete medical records
      </h3>
      <p className="text-gray-600 mt-2 text-sm leading-relaxed">
        We keep all the records like x-rays, before & after photos the entire journey of the patient starting from their first visit on the cloud. This is to ensure high-quality treatment and patient safety.
      </p>
    </div>
  </div>

  {/* ITEM 06 */}
  <div className="flex gap-6">
    <div className="w-16 h-16 flex flex-shrink-0 items-center justify-center bg-blue-400 text-white text-xl font-bold">
      06
    </div>
    <div>
      <h3 className="font-semibold text-lg text-gray-900">
        Periodic Clinical Audits Ensuring 100% Compliance of Standards and Protocols
      </h3>
      <p className="text-gray-600 mt-2 text-sm leading-relaxed">
        The bi-monthly in clinic audits done by Dental Professionals help to maintain the quality of all our clinics and they make sure that the protocols are being followed.
      </p>
    </div>
  </div>

  {/* ITEM 07 */}
  <div className="flex gap-6">
    <div className="w-16 h-16 flex flex-shrink-0 items-center justify-center bg-blue-400 text-white text-xl font-bold">
      07
    </div>
    <div>
      <h3 className="font-semibold text-lg text-gray-900">
        Daily Clinic Fumigation
      </h3>
      <p className="text-gray-600 mt-2 text-sm leading-relaxed">
        SmileExpert is fumigated fortnightly to ensure the elimination of all forms of microbial life including viruses, fungi, bacteria, etc.
      </p>
    </div>
  </div>

</div>

<div className="w-full h-[180px] overflow-hidden mt-4">
  <iframe
    title="clinic-map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.0390050498395!2d71.9162331!3d30.292951199999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b557588a60575%3A0x79afa5462675bee1!2sSmile%20expert%20dental%20clinic!5e0!3m2!1sen!2s!4v1767274320473!5m2!1sen!2s"
    width="100%"
    height="450"
    style={{ border: "0" }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</div>

<div className="bg-[#0c2340] text-white pt-[60px] pb-[60px] px-[40px] mt-0">
  <div className="flex justify-between flex-wrap max-w-[1400px] mx-auto gap-[40px]">
    {/* COLUMN 1 */}
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Useful Links</h3>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    About Us
  </Link>

  <Link to="/contact" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Contact Us
  </Link>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Meet the Team
  </Link>

  <Link to="/teeth-whitening-before-and-after" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Before & After
  </Link>

  <Link to="/blog" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Blogs
  </Link>
</div>


    
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Treatments</h3>

  <Link to="/treatment/exam" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Exam & X-Rays Check-Up
  </Link>

  <Link to="/emergency-dentist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Emergency
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Smile Makeover
  </Link>

  <Link to="/t/veneer" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Veneers
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Implants
  </Link>

  <Link to="t/canals" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Root Canal Treatment
  </Link>

  <Link to="/t/orthodontist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Orthodontic Braces
  </Link>

  
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Dental Problems</h3>

  <Link to="/yellow-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Yellow Teeth
  </Link>

  <Link to="/teeth-cleaning" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Teeth Cleaning
  </Link>

  <Link to="/missing-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Missing Teeth
  </Link>

  <Link to="/broken-chipped-tooth" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Broken Chipped Tooth
  </Link>

  <Link to="/gum-disease" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Gum Disease
  </Link>

  <Link to="/crooked-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Crooked Teeth
  </Link>

  <Link to="/sore-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Sensitive & Sore Teeth
  </Link>

  <Link to="/dental-anxiety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Anxiety
  </Link>
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Patient Safety</h3>

  <Link to="/7x-safety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    7X SAFETY
  </Link>

  <Link to="/4-step-sterilization" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    4 Step Sterilization
  </Link>

  <Link to="/safety-equipment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Safety Equipment
  </Link>

  <Link to="/equipment-technology" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Equipment & Technology
  </Link>

  <Link to="/quality" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Quality
  </Link>
</div>


    <div className="min-w-[250px]">
              <h3 className="text-[20px] mb-[20px]">Get in touch</h3>
        
              <p className="my-2 flex gap-[10px] ">📧 aneelabrar555@gmail.com</p>
        
              <p className="my-3 flex gap-[10px] ">📞 03008395562</p>
        
              <p className="my-2 flex gap-[10px] px-2">
                  <span className="">📍 Saddique Hospital Stadium Road Khanewal</span>
              </p>
        
              <p className="mt-6 font-semibold "> 🕒 Clinic Timing <br/>   <span className="ml-7">11:00am to 9:00pm</span></p>
        
              <div className="text-left bg-[#0c2340] text-white py-[50px] px-[20px]">
                <div className="flex gap-[15px] mt-[20px]">
                  <a

                      href="https://www.facebook.com/share/17zJppb7qh/"

                      target="_blank"

                      rel="noopener noreferrer"

                      className="w-[35px] h-[35px] bg-blue-900 flex justify-center items-center rounded-[8px] no-underline"

                      aria-label="Follow us on Facebook"

                    >

                      <FaFacebookF size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://instagram.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#000000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Follow us on Instagram"

        
                    >

        
                      <FaInstagram size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://youtube.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#FF0000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Subscribe to our YouTube channel"

        
                    >

        
                      <FaYoutube size={22} color="white" />
                  </a>
                </div>
              </div>
            </div>
    
  </div>
   <div className="w-full text-center justify-end mb-0 border-t border-gray-300 pt-4">
  <p className="text-sm text-gray-400">
    © SmileExpert
    <span className="mx-2 text-gray-600">|</span>
    Powered by{" "}
    <a
      href="https://verdant-soft.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-blue-400 no-underline font-medium transition-colors duration-300 "
    >
      Verdant Soft
    </a>
  </p>
</div>

</div>




    </>
  )
}








